import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaPlay, FaPause } from "react-icons/fa";

function CategoryCard({ category }) {
	const [playing, setPlaying] = useState(null);

	const handlePlayPause = (id) => {
		const currentVideo = document.getElementById(`video-${id}`);

		if (playing === id) {
			currentVideo.pause();
			setPlaying(null);
		} else {
			const allVideos = document.querySelectorAll("video");
			allVideos.forEach((video) => {
				video.pause();
			});

			currentVideo.play();
			setPlaying(id);
		}
	};

	return (
		<motion.div
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.7 }}
			className="w-full lg:w-[17rem] h-full bg-white flex flex-col justify-between overflow-hidden"
		>
			<div className="relative group">
				<video
					poster={category?.image || "./images/logo.png"}
					className="w-full h-48 object-cover rounded-xl"
					src={category?.video || "/video/2.mp4"}
					loop
					id={`video-${category._id}`}
					onPause={() => setPlaying(null)}
				></video>

				<div className="absolute inset-0 flex items-center justify-center">
					<button
						onClick={() => handlePlayPause(category._id)}
						className={`w-16 h-16 bg-black bg-opacity-50 rounded-full text-white text-3xl font-bold flex items-center justify-center transition-opacity duration-1000 ease-in-out opacity-0 group-hover:opacity-100 ${
							playing === category._id ? "" : "opacity-100"
						}`}
					>
						{playing === category._id ? <FaPause /> : <FaPlay />}
					</button>
				</div>
			</div>

			<div className="py-6">
				<h1 className="text-black font-medium text-base mb-2 capitalize">
					{category.title}
				</h1>
				<p className="text-gray-500 text-xs line-clamp-3">
					{category.description}
				</p>
			</div>

			<Link to={`/enroll?title=${category.title}`}>
				<button className="bg-white w-full text-black py-3 text-sm border border-gray-400 rounded-full hover:bg-mainColor hover:border-mainColor hover:border-opacity-80 hover:bg-opacity-80 hover:text-white transition duration-500">
					Explore Courses
				</button>
			</Link>
		</motion.div>
	);
}

export default CategoryCard;
